import { createContext } from 'react';
import { configure } from 'mobx';
import CommonStore from './commonStore';
import UserStore from './userStore';
import ModalStore from './modalStore';
import CompaniesStore from "./companiesStore";
import CrifStore from "./crifStore";

configure({ enforceActions: 'always' });

export class RootStore {

    commonStore;
    userStore;
    companiesStore;
    modalStore;

    constructor() {
        this.commonStore = new CommonStore(this);
        this.userStore = new UserStore(this);
        this.crifStore = new CrifStore(this);
        this.companiesStore = new CompaniesStore(this);
        this.modalStore = new ModalStore(this);
    }

}

export const RootStoreContext = createContext(new RootStore());